<div class="container">
    <div class="controls">
        <button mat-button (click)="onAdd()" [disabled]="!selected">Add</button>
        <mat-form-field>
            <mat-label>Groups</mat-label>
            <mat-select [(value)]="selected">
                <mat-option *ngFor="let g of groups" [value]="g.Precedence">
                    {{g.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="groupList">
        <mat-chip-list #chipList>
            <mat-chip
                *ngFor="let n of userGroups"
                (removed)="onRemove(n)">
                {{ n.Name }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>
</div>